import {desktopConfigs} from "./desktopConfigs";
import {mobileConfigs} from "./mobileConfigs";
import {isMobile} from "pixi.js";

export const ASSETS = {
    reelBackground: "slot-board-bg.png",
    slotBoardBg: "slot-board-bg.png",
    cherry: "cherry.png",
    grapes: "grapes.png",
    lemon: "lemon.png",
    orange: "orange.png",
    plum: "plum.png",
    seven: "seven.png",
    star: "star.png",
    watermelon: "watermelon.png"
}

export const SYMBOLS = {
    1: "icon1",
    2: "icon2",
    3: "icon3",
    4: "icon4",
    5: "icon5",
    6: "icon6",
    7: "icon7",
    8: "icon8",
    9: "icon9",
    10: "scatter",
    11: "iconX",
    12: "iconX",
    13: "iconX",
    14: "iconX",
    15: "iconX",
    16: "iconX",
    17: "iconX",
    18: "iconX",
    19: "iconX",
    20: "iconX",
    21: "iconX",
    22: "iconX",
    23: "iconX",
    24: "iconX",
    25: "iconX",
}

export const multipliersNumsById = {
    11: 2,
    12: 3,
    13: 4,
    14: 5,
    15: 6,
    16: 8,
    17: 10,
    18: 12,
    19: 15,
    20: 20,
    21: 25,
    22: 50,
    23: 100,
    24: 250,
    25: 500,
};

export const VISUAL_HIGHER_ORDER_ICONS_NAMES = ["scatter", "X2", "X3", "X4", "X5", "X7", "X8", "X10", "X20", "X30", "X50", "X100"];

export const SYMBOLS_ID = {
    wild3x: 1,
    wild2x: 2,
    wild: 3,
    male: 4,
    female: 5,
    greenFigure: 6,
    redFigure: 7,
    purpleFigure: 8,
    greenStone: 9,
    redStone: 10,
    blueStone: 11,
    scatter: 12,
}

export const SLOT_BOARD = isMobile.phone ? mobileConfigs.slotBoard : desktopConfigs.slotBoard;

export const REEL = isMobile.phone ? mobileConfigs.reels : desktopConfigs.reels;

export const CANVAS = isMobile.phone ? mobileConfigs.canvasSize : desktopConfigs.canvasSize;

export const reelsStoppingAnimDelay = {
    normal: 250,
    turbo: 5,
}

export const spinAnimationConfig = {
    reelsSpeed: isMobile.phone ? 40 : 70,
    autoSpinWinShowDelay: 1500,
    yBlur: 20,
}
